export const handleCash = (riskType: string, breakdowns: any) => {
  if (!breakdowns.find((bk: any) => bk.instrument === 'TOTAL' && bk.contract === 'CASH')) {
    return null;
  }

  return {
    id: `${riskType}-cash`,
    label: 'Cash',
    values: breakdowns.find((bk: any) => bk.instrument === 'TOTAL' && bk.contract === 'CASH')?.risk,
  };
};
